'use client'

import Button, { ButtonProps } from '@/components/ui/button'
import { useTranslations } from 'next-intl'
import { useAuthModal } from './useAuthModal'

export default function RegisterButton({ children, ...props }: ButtonProps) {
  const { onOpen: openAuthModal } = useAuthModal()
  const t = useTranslations('header')

  const handleClick = () => {
    openAuthModal('register')
  }

  return (
    <Button
      variant='primary'
      fontSize='xs'
      size='md'
      onClick={handleClick}
      data-tag-id='Register'
      {...props}
    >
      {children ?? t('register-button')}
    </Button>
  )
}
